export default {
    required: "Ce champ est obligatoire.",
    alphabetic: "Seuls les caractères alphabétiques et les espaces sont autorisés.",
    alphanumeric: "Seuls les caractères alphanumériques et les espaces sont autorisés.",
    phone: "Format de numéro de téléphone invalide.",
    id_number: "Le numéro du document doit contenir entre 6 et 9 lettres ou chiffres. Si ce numéro est plus long sur le passeport, il suffit d’encoder les 9 premiers caractères.",
    email: "Format d'email invalide."
}
